export default {
    //baseUrl: "http://localhost:8089/" // 本地开发
    baseUrl: "https://admin.ciaojian.com/" // 生产环境
    //baseUrl: "https://admindev.ciaojian.com/" // 测试环境
}
